import { useEffect, useState } from 'react'
import * as signalR from '@microsoft/signalr'

let presenceConnection = null

// Batch-06: module-level fan-out for realtime notifications on the shared presence hub.
// Any component can subscribe regardless of which hook instance started the hub.
const notificationListeners = new Set()
const reconnectListeners = new Set()

export const subscribeToNotifications = (cb) => {
  notificationListeners.add(cb)
  return () => notificationListeners.delete(cb)
}

export const subscribeToPresenceReconnect = (cb) => {
  reconnectListeners.add(cb)
  return () => reconnectListeners.delete(cb)
}

const emitNotification = (payload) =>
  notificationListeners.forEach((cb) => {
    try {
      cb(payload)
    } catch (e) {
      // a listener error must not break realtime delivery to the others
    }
  })

const emitReconnect = () =>
  reconnectListeners.forEach((cb) => {
    try {
      cb()
    } catch (e) {
      // ignore
    }
  })

const useSignalRPresence = () => {
  const [unreadMessages, setUnreadMessages] = useState(0)

  const startPresenceHub = () => {
    if (!presenceConnection) {
      presenceConnection = new signalR.HubConnectionBuilder()
        .withUrl(`${process.env.REACT_APP_BASE_URL}/hubs/presence`, {
          accessTokenFactory: () => localStorage.getItem('token'),
        })
        .withAutomaticReconnect()
        .build()

      presenceConnection
        .start()
        .then(() => console.log('Presence Hub Connected'))
        .catch((err) => console.error('Presence Hub Error:', err))

      presenceConnection.on('GetUnReadMessages', (unread) => {
        setUnreadMessages(() => unread) // Functional update
      })

      presenceConnection.on('UpdateMessageCount', (count) => {
        setUnreadMessages(() => count) // Functional update
      })

      // Batch-06: event-driven in-app notifications. Fan out to any subscriber
      // (the notification bell / store). SignalR is a realtime convenience only;
      // the HTTP notification APIs remain the source of truth on reconnect/refresh.
      presenceConnection.on('NotificationReceived', (notification) => {
        emitNotification(notification)
      })

      presenceConnection.onreconnected(() => {
        emitReconnect()
      })
    }
  }

  const stopPresenceHub = () => {
    if (presenceConnection) {
      presenceConnection
        .stop()
        .then(() => console.log('Presence Hub Disconnected'))
        .catch((err) => console.error('Error stopping Presence Hub:', err))
      presenceConnection = null
    }
  }

  useEffect(() => {}, [unreadMessages])

  return { unreadMessages, startPresenceHub, stopPresenceHub }
}

export default useSignalRPresence

// import { useEffect, useState } from 'react'
// import * as signalR from '@microsoft/signalr'

// const useSignalRPresence = () => {
//   const [unreadMessages, setUnreadMessages] = useState(0)
//   useEffect(() => {
//     const presenceConnection = new signalR.HubConnectionBuilder()
//       .withUrl(`${process.env.REACT_APP_BASE_URL}/hubs/presence`, {
//         accessTokenFactory: () => localStorage.getItem('token'),
//       })
//       .withAutomaticReconnect()
//       .build()

//     presenceConnection.start().catch((err) => console.error('Presence Hub Error:', err))

//     presenceConnection.on('GetUnReadMessages', (unread) => setUnreadMessages(unread))
//     presenceConnection.on('UpdateMessageCount', (count) => setUnreadMessages(count))

//     return () => presenceConnection.stop()
//   }, [])
//   return { unreadMessages }
// }

// export default useSignalRPresence
